var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright-box",attrs:{"id":"copyright-box"}},[(_vm.$store.state.userAgent === 'Mobile')?_c('title-nav'):_vm._e(),_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":_vm.copyRightUrl,"alt":"","width":"100%"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }